import { useQuery } from '@tanstack/react-query';
import { fabryApi, getFabryRequestConfig } from '../api';
import type { ChatHistoryItem } from '../types';

export const QUERY_KEY_CHAT_HISTORY = 'chatHistory';

const fetchChatHistory = async (): Promise<ChatHistoryItem[]> => {
  const { data } = await fabryApi.listChatsApiV1ChatsGet(
    undefined,
    getFabryRequestConfig()
  );
  return data.chats;
};

export const useChatHistory = ({ enabled }: { enabled?: boolean } = {}) =>
  useQuery({
    queryKey: [QUERY_KEY_CHAT_HISTORY] as const,
    queryFn: fetchChatHistory,
    enabled,
  });
